export const gbInBytes = gb => (
  gb * 1024 * 1024 * 1024
)

export const validateFileSize = (file, limit) => (
  file.size <= limit
)

// taken from QM
export const dataUriToBlob = uri => {
  var hasArrayBufferView = new Blob([new Uint8Array(100)]).size === 100
  var data = uri.split(',')[1]
  var bytes = typeof atob === 'undefined' ? window.atob(data) : atob(data)
  var buf = new ArrayBuffer(bytes.length)
  var arr = new Uint8Array(buf)
  for (var i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i)
  }

  if (!hasArrayBufferView) {
    arr = buf
  }
  var blob = new Blob([arr], { type: uri.split(';')[0].slice(5) })
  blob.slice = blob.slice || blob.webkitSlice
  return blob
}
